import { lazy } from 'react';

const RELOAD_KEY = 'chunk_reload';

const lazyWithRetry = (importFn) =>
  lazy(() =>
    importFn()
      .then((module) => {
        sessionStorage.removeItem(RELOAD_KEY);
        return module;
      })
      .catch((error) => {
        const hasReloaded = sessionStorage.getItem(RELOAD_KEY);

        if (!hasReloaded && error?.name === 'ChunkLoadError') {
          sessionStorage.setItem(RELOAD_KEY, '1');
          window.location.reload();
          return new Promise(() => {});
        }

        sessionStorage.removeItem(RELOAD_KEY);
        throw error;
      })
  );

export default lazyWithRetry;
